import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import "./Groups.css";
import { Link, useSearchParams } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { groupListingApi } from "../../../services/groups";
import { groupType } from "../../../utils/staticData";
import { tabHandler } from "../../../utils/regexValidation";
import MyGroup from "./groupSubModules/MyGroup";
import JoinedGroup from "./groupSubModules/JoinedGroup";
import ExploreGroup from "./groupSubModules/ExploreGroup";
import useDebounce from "../../../hooks/useDebounce";
import FavouriteGroup from "./groupSubModules/FavouriteGroup";
import { toastMessage } from "../../../utils/toastMessage";

const Groups = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const debouncedValue = useDebounce(search, 300);
  let type = searchParam.get("type") || "";
  const [groupList, setGroupList] = useState([]);
  const [exploreSearch, setExploreSearch] = useState("");
  const [favoriteSearch, setFavoriteSearch] = useState("");
  const [hasMore, setHasMore] = useState(true);

  //--------search-handler-----------
  const searchHandler = (e, type) => {
    const { name, value } = e.target;
    if (type === "explore") {
      setExploreSearch(value);
    }
    if (type === "favourite") {
      setFavoriteSearch(value);
    } else {
      setSearch(value)
    }
  }

  //--------------listing-API-------------------
  const fetchingGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await groupListingApi({
        type: type,
        pagination: "true",
        search: debouncedValue,
        limit: 12,
        page,
      });
      const { data: groupList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setGroupList(groupList || []);
        } else {
          setGroupList((prev) => [...prev, ...(groupList || [])]);
        }
        setHasMore(groupList.length === 12);
      } else {
        toastMessage(message, "error", "groupList");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchingGroupListHandler(1, true);
  }, [debouncedValue, type]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      fetchingGroupListHandler(nextPage);
      return nextPage;
    });
  };
  //-------when-change-tab------------
  useEffect(() => {
    setPage(1);
    setSearch("");
    setExploreSearch("");
    setFavoriteSearch("");
  }, [type]);

  return (
    <>
      {/* Group_Header_Start */}
      <DashboardHeader title={"Groups"} />
      <div className="GroupPage">
        <div className="grp_Navbar">
          <div className="tab_button_wrap">
            <ul>
              {groupType?.map((data, ind) => (
                <li key={ind}>
                  <button
                    type="button"
                    onClick={() =>
                      tabHandler(
                        "type",
                        data?.value,
                        searchParam,
                        setSearchParam
                      )
                    }
                    className={type === data?.value ? "active" : ""}
                  >
                    {data?.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="gro_Navbar_search">
            <div className="search_group">
              <CiSearch />
              <input
                type="text"
                className="search_bar"
                placeholder="Search here"
                value={search || favoriteSearch || exploreSearch}
                onChange={(e) => searchHandler(e, type)}
              />
            </div>

            {type === "" && (


              <Link
                to="/dashboard/group/create-group"
                className="create_group_btns"
              >
                Create Group
                <div className="icon">+</div>
              </Link>
            )}
          </div>
        </div>

        {type === "favourite" && <FavouriteGroup {...{ favoriteSearch }} />}

        {type === "" && (<MyGroup {...{ groupList, fetchMoreData, hasMore, setGroupList }} />)}

        {type === "joined" && (<JoinedGroup {...{ groupList, fetchMoreData, hasMore, setGroupList }} />)}

        {type === "explore" && (<ExploreGroup {...{ exploreSearch }} />)}

      </div>
    </>
  );
};

export default Groups;
